import { gsap } from "gsap";
import $ from "jquery";

$(document).ready(() => {
  const closeOpenFaqs = () => {
    $('.faq-question.active').each(function () {
      const $this = $(this);
      const $answer = $this.next('.faq-answer');
      gsap.to($answer, {
        height: 0,
        paddingTop: 0,
        paddingBottom: 0,
        duration: 0.3,
        ease: 'power2.out',
        onComplete: () => {
          $answer.hide();
          $this.removeClass('active');
        }
      });
    });
  };

  $('.faq-question').on('click', function () {
    const $this = $(this);
    const $answer = $this.next('.faq-answer');
    if ($this.hasClass('active')) {
      gsap.to($answer, {
        height: 0,
        paddingTop: 0,
        paddingBottom: 0,
        duration: 0.3,
        ease: 'power2.out',
        onComplete: () => {
          $answer.hide();
          $this.removeClass('active');
        }
      });
    } else {
      $answer.show().css('height', 'auto');
      const autoHeight = $answer[0].scrollHeight;
      $answer.css('height', 0);
      gsap.to($answer, {
        height: autoHeight + 24,
        marginTop: -1,
        duration: 0.3,
        ease: 'power2.out'
      });
      $this.addClass('active');

      $('.faq-question.active').not($this).each(function () {
        const $activeAnswer = $(this).next('.faq-answer');
        gsap.to($activeAnswer, {
          height: 0,
          paddingTop: 0,
          paddingBottom: 0,
          duration: 0.3,
          ease: 'power2.out',
          onComplete: () => {
            $activeAnswer.hide();
            $(this).removeClass('active');
          }
        });
      });
    }
  });

  $(window).on('resize', () => {
    closeOpenFaqs();
  });
});
